var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookingLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 122,
    viewBox: "0 0 171 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.13 10.4504L114.98 5.40039L114.18 14.1204L122.13 10.4504Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3797 14.8298C92.4346 14.8298 93.2897 13.9746 93.2897 12.9198C93.2897 11.8649 92.4346 11.0098 91.3797 11.0098C90.3249 11.0098 89.4697 11.8649 89.4697 12.9198C89.4697 13.9746 90.3249 14.8298 91.3797 14.8298Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3107 3.80062L62.2783 9.01562L67.4933 18.048L76.5257 12.833L71.3107 3.80062Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 1.32031L54.4997 25.5003",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17 110.4L50 121.71L60.38 117.06L51.17 110.4Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0336 43.6506L10.1826 41.75L8.28201 46.601L13.133 48.5016L15.0336 43.6506Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.04 112.55L115.53 107.95L114.81 115.89L122.04 112.55Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 120.5L29.5 103.5",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46973 107.3L22.2297 98.4004",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6201 22.7598L49.5001 27.4998",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69 28.79C150.72 23.49 160.23 17.2 169.02 10.04C169.62 9.54998 170.25 9.01998 170.48 8.27998C170.71 7.53998 170.36 6.55998 169.59 6.42998C169.26 6.36998 168.92 6.47998 168.6 6.59998C164.39 8.10998 160.52 10.41 156.67 12.7C150.37 16.45 144.06 20.2 137.76 23.96",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.98 33.4496C126.07 33.1796 127.04 32.5596 127.99 31.9596C130.09 30.6196 132.19 29.2696 134.29 27.9296C134.8 27.6096 135.33 27.2696 135.93 27.2296C136.53 27.1896 137.2 27.5496 137.29 28.1396C137.39 28.8396 136.7 29.3696 136.1 29.7396C134.07 30.9596 132.04 32.1796 130.01 33.4096C129.61 33.6496 129.16 33.9696 129.15 34.4396C129.15 34.7096 129.3 34.9596 129.42 35.1996C130.14 36.5996 129.68 38.7296 128.15 39.1196C126.86 39.4496 125.65 38.4596 124.66 37.5796C122.73 35.8596 120.6 34.8096 118.5 33.3996C120.6 32.9196 122.83 33.9796 124.98 33.4496Z",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.25 69.5996C133.25 88.4996 106.89 106.57 74.37 106.57C41.85 106.57 15.5 88.4996 15.5 69.5996",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 46.5895C128.29 52.4895 133.26 60.0195 133.26 68.2295C133.26 87.1295 106.9 102.46 74.38 102.46C41.86 102.46 15.5 87.1295 15.5 68.2295C15.5 52.1895 34.47 38.7295 60.08 35.0195",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8701 46.5097C88.6701 41.6297 95.4301 40.5297 99.0001 36.1797C89.9401 33.7797 80.4901 32.8697 71.1401 33.4797C66.6201 33.7697 62.0201 34.4597 58.0001 36.5597C56.6701 37.2497 55.4001 38.1097 53.9401 38.4397C52.7901 38.6997 51.5801 38.6197 50.4101 38.7997C48.7901 39.0497 47.2901 39.7997 45.8301 40.5397C40.2901 43.3397 34.6101 46.2497 30.5001 50.8997C29.1001 52.4797 27.8901 54.2797 27.3801 56.3197C26.8901 58.2697 27.0701 60.3097 27.2501 62.3197C27.4501 64.5297 27.6501 66.7397 27.8501 68.9497C28.1401 72.1697 28.4901 75.5497 30.3801 78.1697C32.9601 81.7397 37.6301 82.9097 41.7501 84.4697C48.8001 87.1497 55.2801 91.6497 62.7501 92.6797C65.0501 92.9997 67.6901 92.8497 69.2401 91.1397C70.8201 92.0197 72.7401 91.8497 74.5401 91.6597C76.3301 91.4697 78.1201 91.2797 79.9101 91.0897C90.7701 89.9397 101.68 88.7697 112.2 85.8297C113.13 85.5697 114.1 85.2697 114.77 84.5697C115.33 83.9797 115.61 83.1797 116.01 82.4697C117.13 80.5097 119.19 79.3297 121 77.9697C123.51 76.0897 125.65 73.7197 127.28 71.0497C127.81 70.1797 128.29 69.2497 128.47 68.2397C128.64 67.2497 128.5 66.2297 128.36 65.2397C127.93 62.1997 127.51 59.1597 127.08 56.1297C126.94 55.1297 126.78 54.0797 126.14 53.2997C125.01 51.9097 122.91 51.9197 121.12 52.0597C118.05 52.2997 114.98 52.5297 111.91 52.7697C108.52 53.0297 105.12 53.2897 101.77 53.8897C94.9601 55.0997 88.2001 57.7597 81.1801 57.2097C77.1501 56.8897 79.1901 55.6697 81.3401 54.0197C83.9801 51.9597 84.3001 49.2497 85.8701 46.5097Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7098 53.7799C88.8598 51.9899 91.1998 50.4299 93.6698 49.1099C94.7898 48.5099 95.9498 47.9599 97.1898 47.7199C99.6898 47.2399 102.23 48.0499 104.73 48.5199C111.39 49.7599 118.5 48.4099 124.26 44.8299C125.82 43.8599 127.35 42.6499 128.11 40.9799C128.27 40.6299 128.39 40.1999 128.21 39.8599C128.06 39.5799 127.76 39.4299 127.46 39.3399C125.98 38.8599 124.36 39.2799 122.88 39.7599C119.29 40.9299 115.79 42.5199 112.03 42.9099C109.38 43.1799 106.71 42.8399 104.04 42.8699C97.6198 42.9399 90.4598 45.2999 85.7598 49.8099C86.4198 50.3399 87.5598 53.0799 86.7098 53.7799Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2796 36.7097C95.6596 39.1497 91.5196 40.7997 88.0596 43.4697C86.7496 44.4797 85.5196 45.6697 84.8196 47.1597C84.0996 48.6897 83.9696 50.4797 83.0596 51.9097C88.0696 47.5597 93.8396 43.5197 100.45 42.8997C104.13 42.5497 107.84 43.2997 111.54 43.1697C113.87 43.0897 119.27 40.9997 121.56 40.5697C124.65 39.9897 124.65 41.0797 127.74 40.4997C127.81 39.0297 126.78 37.6997 125.54 36.9097C124.3 36.1197 122.85 35.7397 121.47 35.2097C118.81 34.1897 116.4 32.5897 113.79 31.4297C111.51 30.4097 107.92 29.0597 105.75 30.7797C103.46 32.5797 101.78 35.0197 99.2796 36.7097Z",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9404 52.2802C85.8704 50.0602 88.1104 48.1002 90.5804 46.4902C92.0504 45.5302 93.6204 44.6802 95.3004 44.1502C97.6104 43.4202 100.05 43.3002 102.47 43.1902C104.04 43.1202 105.61 43.0502 107.17 43.2202C108.35 43.3502 109.53 43.6202 110.72 43.6102C112.09 43.5902 113.43 43.2002 114.75 42.8202C117.1 42.1302 119.45 41.4402 121.8 40.7502C123.79 40.1602 126.07 39.6102 127.84 40.7102C127.13 42.4702 125.38 43.5402 123.74 44.4902C120.1 46.5802 116.29 48.6902 112.11 49.0202",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.47 48.7203C105.86 48.0703 100.3 47.5403 98.5596 47.6203C96.6896 47.7003 94.7397 47.8203 93.1497 48.8003C92.4497 49.2303 91.8496 49.8203 91.1696 50.2803C90.1696 50.9603 88.9596 51.4203 88.2696 52.4103C87.3996 53.6703 87.4696 55.6303 86.1396 56.3803",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.49 40.0104C126.25 38.0804 124.16 36.8804 122.15 35.7604C120.65 34.9304 119.16 34.0904 117.66 33.2604C116.36 32.5404 115.05 31.8104 113.66 31.2804C111.62 30.5104 109.42 30.2004 107.24 30.1904C106.93 30.1904 106.61 30.2004 106.36 30.3704C106.06 30.5704 105.92 30.9404 105.77 31.2704C104.93 33.1004 103.17 34.3104 101.48 35.4104C97.5796 37.9804 93.6696 40.5504 89.6196 42.8804C88.4796 43.5304 87.3096 44.2004 86.4996 45.2304C84.8096 47.3904 85.0096 50.8304 82.8096 52.4604",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.51 52.6097C109.59 51.5497 110.11 50.5797 110.67 49.6897C112.31 47.0597 115.71 44.0797 118.19 42.2197",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31 43.5903C107.5 43.3703 107.84 43.6503 107.98 43.9003C108.96 45.7703 108.07 51.2203 107.24 53.1603",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9203 44.0098C99.1903 44.1298 99.5103 44.1498 99.7903 44.0598C97.8303 45.1298 96.8503 47.3998 96.3103 49.5698C95.7703 51.7398 95.5103 54.0298 94.3903 55.9698C94.9103 55.3098 95.0703 54.4398 95.1803 53.5998C95.4503 51.4998 95.4803 49.3698 95.2703 47.2698C95.2203 46.7398 95.1503 46.1898 94.8803 45.7298C94.6103 45.2698 94.1003 44.9098 93.5703 44.9898",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48 57.2796C80.6 56.1396 88.16 56.4296 90.57 56.5096C95 56.6696 99.35 55.4896 103.68 54.5296C108.82 53.3896 114.03 52.5696 119.27 52.0596C121.66 51.8296 124.3 51.7196 126.22 53.1696C126.73 53.5596 127.18 54.0696 127.36 54.6796C127.57 55.4296 127.36 56.2296 127.28 57.0096C126.91 60.7396 129.7 64.4096 128.74 68.0296C128.25 69.8796 126.86 71.3396 125.52 72.6996C123.18 75.0796 120.85 77.4596 118.51 79.8396C118.16 80.1896 117.76 80.5696 117.27 80.5696C116.88 80.5696 116.53 80.3396 116.21 80.1096C114.17 78.6496 112.18 77.1096 110.07 75.7496C103.81 71.7496 96.54 69.4896 90.39 65.3096C86.23 62.4796 82.59 58.7796 77.96 56.8096",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4003 57.0801C76.7003 63.3501 74.9603 69.5101 72.2503 75.2201C70.9503 77.9601 69.4203 80.6301 68.7603 83.5901C68.1003 86.5501 68.4603 89.9401 70.5603 92.1201C82.5203 91.2601 94.5303 90.4001 106.27 87.9201C108.26 87.5001 110.25 87.0301 112.06 86.1001C113.87 85.1701 115.48 83.7401 116.25 81.8601",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4902 84.8904C77.9002 84.2204 79.7802 84.8504 80.5102 86.2304",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29 83.0599C89.95 82.8399 91.65 82.9099 93.29 83.2499",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7598 81.5797C98.6098 80.4597 100.91 80.1197 103.01 80.6597",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.45 71.1996C117.4 70.9196 119.42 71.1796 121.24 71.9296",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56 66.5801C122.54 66.9601 123.47 67.4401 124.35 68.0201C124.78 68.3001 125.24 68.7001 125.22 69.2101",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7603 76.3397C29.3503 75.8097 29.6403 75.0097 30.0603 74.4897C31.3203 72.9497 33.4303 72.4597 35.3703 72.0297C45.9203 69.6997 56.1903 66.2797 66.3703 62.6797C70.4803 61.2297 74.7003 59.6797 77.8603 56.6797C77.6403 56.7997 77.4303 56.9297 77.2103 57.0497",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1305 75.75C38.1105 75.84 37.3305 76.79 37.1005 77.79C36.8705 78.79 37.0805 79.83 37.2805 80.84C37.4005 81.46 37.6105 82.18 38.2105 82.38",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1402 75.4502C29.7102 76.7002 30.2402 78.1202 31.1402 79.1002C32.0302 80.0802 33.2302 80.7002 34.4102 81.3102C36.4302 82.3502 38.4402 83.3802 40.4602 84.4202C42.4902 85.4702 44.5302 86.5102 46.6602 87.3502C47.9402 87.8502 49.2402 88.2702 50.5202 88.7802C51.6902 89.2402 52.8302 89.7602 54.0202 90.1602C55.3802 90.6102 56.7802 90.8902 58.1802 91.1702C60.5902 91.6502 63.0002 92.1202 65.4002 92.6002C65.9602 92.7102 66.5502 92.8202 67.1002 92.6502C68.4302 92.2302 68.7302 90.5202 68.7902 89.1302",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3701 75.93C29.2801 72.49 27.9301 69.18 27.7701 65.73C27.6901 63.97 27.9201 62.2 28.1501 60.45C28.4401 58.28 28.7201 56.11 29.0101 53.94C29.0901 53.34 29.1801 52.72 29.5201 52.23C30.4201 50.95 32.3601 51.28 33.8801 51.68C40.7401 53.5 47.8701 53.94 54.9301 54.57C63.0901 55.3 71.2201 56.31 79.3101 57.58",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5303 74.7403C29.5303 74.0303 29.8003 72.6803 30.4503 71.6303C31.4503 70.0003 33.3603 69.1303 35.2403 68.7603C37.1203 68.3803 39.0603 68.4003 40.9403 68.0503C42.4403 67.7703 43.8903 67.2503 45.3803 66.8903C48.7303 66.0703 52.2303 66.0103 55.6103 65.3003C60.5703 64.2503 65.3003 61.7803 70.3603 61.8903",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4404 51.2801C33.9404 48.5701 37.4504 45.8501 40.9504 43.1401C42.5804 41.8701 44.2404 40.5901 46.1404 39.7801C48.9004 38.5901 52.0504 38.4601 55.0004 39.0501C54.9104 40.6301 56.7004 41.5401 58.1004 42.2701C63.2804 44.9601 66.5304 50.4701 71.6804 53.2101C73.8604 54.3701 76.5704 55.2501 77.4704 57.5501",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4502 39.4502C56.7002 36.9402 59.8202 35.2302 63.1402 34.6802C64.6302 34.4302 66.1502 34.4102 67.6502 34.2102C69.3402 33.9802 71.0002 33.5302 72.6902 33.2802C75.1202 32.9202 77.6202 33.0002 80.0302 33.5102C80.3202 33.5702 80.6502 33.6702 80.7902 33.9302C80.9202 34.1802 80.8402 34.4902 80.7502 34.7602C79.5302 38.6402 78.7302 42.6502 78.3502 46.7002C78.1902 48.3802 78.1102 50.0802 77.6102 51.6802C77.0002 53.6502 75.8002 55.7802 76.7402 57.6102",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.21 33.82C84.19 33.46 87.29 33.11 90.12 34.12C91.06 34.46 93.6 35.07 94.51 35.5C96.7 36.55 96.6 36.74 99.03 36.74",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56 33.6105C121.12 33.6305 122.67 33.6505 124.23 33.6705C124.69 33.6805 125.15 33.6805 125.6 33.5705C126.25 33.4005 126.81 33.0005 127.35 32.6105C129.96 30.7405 132.68 29.0305 135.5 27.4805",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18 27.3997C136.4 27.1497 137.71 28.1897 137.74 29.4397",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54 24.7795C139.9 24.7595 141.04 26.2995 140.61 27.5995",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33 28.0303C139.58 28.5003 138.83 28.9603 138.07 29.4303",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.96 23.9199C138.21 24.3899 136.09 26.2199 135.34 26.6899",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 28.8701C134.21 30.6101 131.57 32.5001 129.02 34.5101C129.69 35.2301 130.11 36.1801 130.16 37.1601C130.17 37.3101 130.17 37.4701 130.1 37.6001C130.01 37.7801 129.82 37.8701 129.64 37.9701C128.57 38.5401 127.63 39.3301 126.89 40.2901",
    stroke: "#F06595",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8598 42.7898C68.7998 42.7898 68.8398 42.6697 68.8998 42.6897C68.9598 42.7097 68.9798 42.7897 68.9898 42.8497C69.0298 43.2397 69.0398 43.6297 69.0198 44.0097",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2905 45.9805C73.2705 46.1505 73.2505 46.3305 73.2305 46.5005C73.2405 46.3305 73.2605 46.1505 73.2705 45.9805",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3801 39C72.3601 39.28 72.3501 39.56 72.3301 39.84C72.3401 39.56 72.3501 39.28 72.3701 39",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4297 50.2496C51.9497 49.9796 52.6197 50.0196 53.0897 50.3696",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1201 51.5998C61.2801 51.8298 61.5001 52.0198 61.7601 52.1298C61.5501 51.9498 61.3401 51.7698 61.1301 51.5898",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4297 47.0196C56.8597 46.9996 57.2897 47.2696 57.4697 47.6596",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4902 58.5703C57.8702 58.4103 58.3002 58.3603 58.7102 58.4303",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7803 59.4999C65.2303 59.3899 65.6903 59.2799 66.1403 59.1699",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8398 72.9598C64.4498 72.5598 65.0598 72.1598 65.6698 71.7598",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4902 66.48C69.7002 66.33 69.9002 66.18 70.1102 66.04",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4697 62.2097C99.3697 62.0597 100.29 62.0097 101.2 62.0697",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 59.6399C107.07 59.2199 107.78 58.9899 108.48 59.0299",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2598 71.1904C85.6698 71.2904 85.9998 71.6604 86.0498 72.0804",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9502 77.0898C80.0102 77.5498 80.2202 77.9898 80.5502 78.3098",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3301 82.6799C53.9901 81.9199 56.1001 82.2299 57.4601 83.4499C57.8001 83.7499 58.1101 84.1099 58.5201 84.3099C59.4301 84.7399 60.4701 84.2499 61.4301 83.9399C63.6601 83.2099 66.2101 83.5299 68.1901 84.7799",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21 57.9301C124.69 57.8301 126.18 58.7701 126.72 60.1401C126.75 60.2301 126.78 60.3201 126.75 60.4101C126.71 60.4901 126.57 60.5201 126.53 60.4401C126.49 60.3601 126.68 60.3101 126.66 60.4001",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42 54.2305C125.96 54.4105 127.26 55.8105 127.33 57.3605",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.13 63.79C30.01 64.1 28.28 66.14 28.31 68.29",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1802 57.1201C30.4402 57.6101 29.8102 58.2801 29.3802 59.0601C29.2502 59.3001 29.1702 59.6701 29.4102 59.7901",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2695 56.8005C78.6395 55.4005 80.4995 54.5605 81.9095 53.2005C82.4595 52.6705 82.9595 52.0505 83.6695 51.7305",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6502 50.2197C87.0602 50.9597 87.3601 51.7897 87.3401 52.6297C87.3201 53.8797 86.6102 55.0097 85.9102 56.0497",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8896 41.2002C96.1396 40.9702 96.4597 40.8102 96.7997 40.7402",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.52 41.2002C100.93 41.1302 101.33 41.0602 101.74 40.9902",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9697 44.7596C90.3297 44.5796 90.7097 44.4496 91.1097 44.3896",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.77 36.7197C103.58 36.9897 103.45 37.3097 103.4 37.6397",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13 40.5195C106.9 40.8195 106.67 41.1295 106.45 41.4295",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.59 48.71C80.65 49.04 80.63 49.38 80.54 49.7",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3096 42.3398C82.4596 42.6198 82.5096 42.9398 82.4596 43.2498",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0698 41.3398C87.5298 41.5698 87.0798 41.9798 86.7998 42.4998",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.96 53.27C107.53 53.66 108.35 53.43 108.84 52.94C109.33 52.45 109.58 51.78 109.86 51.15C110.3 50.12 110.84 49.13 111.52 48.25C113.64 45.51 118.48 44.31 120.5 41.5C116.93 43.84 110.38 43.28 109.75 43.33C109.53 43.35 108.26 43.15 108.14 43.22C107.39 43.69 107.94 45.2 107.99 45.98C108.03 46.65 107.12 53.39 106.96 53.27Z",
    fill: "#E64980",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2597 46.6398C95.5997 49.8198 94.9097 53.0098 94.2197 56.1398C95.5697 53.4698 96.5697 50.6198 97.1697 47.6898C97.2897 47.0998 97.3997 46.4998 97.6697 45.9698C98.3097 44.7298 99.4897 43.5098 100.49 43.5098C98.4897 43.5098 95.2597 44.4398 94.4797 44.9798C94.9497 45.4398 95.1897 45.9698 95.2597 46.6398Z",
    fill: "#E64980",
    stroke: "#E64980",
    strokeWidth: 1.4833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44 42.6701L165.5 31.0801",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingLeftImage);
export default __webpack_public_path__ + "static/media/cookingLeftImage.1aad4a2e3057eaf36845e16e5e6d9587.svg";
export { ForwardRef as ReactComponent };